<template>
  <div
    class="subprogram-payment-input-info-base"
    :class="{ 'subprogram-payment-input-info-base--no-label': !label }"
  >
    <!-- Label -->
    <div
      v-if="label || infoTooltip"
      class="subprogram-payment-input-info-base__label"
    >
      <span
        v-if="label"
        v-text="label"
        class="subprogram-payment-input-info-base__label__text"
      />
      <el-tooltip
        effect="dark"
        placement="right"
        class="subprogram-payment-input-info-base__label__tooltip"
      >
        <div slot="content">
          <app-i18n code="entities.subprogram.form.payment.fee.seeDetailsText" />
          <span v-text="' '" />
          <a
            class="subprogram-payment-input-info-base__label__tooltip__link"
            @click.prevent.stop="goToInfoPage"
          >
            <app-i18n code="entities.subprogram.form.payment.fee.seeDetailsLinkText" />
          </a>
        </div>
        <i
          v-if="infoTooltip"
          class="subprogram-payment-input-info-base__label__icon icon-info"
          @click.prevent.stop="goToInfoPage"
        />
      </el-tooltip>
    </div>

    <!-- Body -->
    <div class="subprogram-payment-input-info-base__body">
      <!-- Icon -->
      <i
        v-if="iconClass"
        class="subprogram-payment-input-info-base__body__icon"
        :class="iconClass"
      />

      <!-- Text -->
      <span
        v-if="!textEmpty"
        class="subprogram-payment-input-info-base__body__text"
      >
        <span
          v-if="percent"
          v-text="`${percent}%`"
        />
        <span
          v-if="percent && amount"
          v-text="' + '"
        />
        <app-i18n-amount
          v-if="amount"
          :amount="amount * 100"
          :currency="currency"
        />
      </span>

      <span
        v-else
        class="subprogram-payment-input-info-base__body__empty"
        v-text="textEmpty"
      />
    </div>

    <span
      class="subprogram-payment-input-info-base__information"
      v-text="info"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'subprogram-payment-input-info-base',
  props: {
    label: String,
    infoTooltip: Boolean,
    textEmpty: {
      type: String,
    },
    amount: {
      type: Number,
    },
    currency: {
      type: String,
    },
    percent: {
      type: Number,
    },
    info: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
    }),
    tooltipRoute() {
      return {
        name: 'subpropertyFeeInfo',
        id: this.currentManage.subproperty.id,
      }
    },
  },
  methods: {
    goToInfoPage() {
      this.$router.push(this.tooltipRoute)
    },
  },
};
</script>

<style lang="scss" scoped>
  .subprogram-payment-input-info-base {
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-gap: 10px;
    padding: 0 15px;
    align-items: center;

    &--no-label {
      grid-template-rows: 1fr 1fr;
      grid-gap: 4px;
    }

    &--no-label &__information {
      align-self: start;
      color: #c5c5c5;
    }

    &:first-of-type {
      padding-left: 0;
    }

    &__label {
      font-size: 12px;
      color: #c5c5c5;
      line-height: 1;
      display: grid;
      grid-auto-flow: column;

      &__icon {
        justify-self: end;
        cursor: pointer;
      }

      &__tooltip {
        font-size: 12px;

        &__link {
          color: #2acccc;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    &__body {
      display: grid;
      grid-template-columns: 18px 1fr;
      grid-gap: 8px;

      &__icon {
        align-self: center;
        justify-self: center;
        font-size: 18px;
        line-height: 1;
      }

      &__text {
        color: #404040;
        font-size: 14px;
        line-height: 1;

        display: grid;
        grid-template-columns: auto auto 1fr;
        grid-gap: 4px;
        align-content: center;
      }

      &__empty {
        line-height: 1;
        text-align: center;
      }
    }

    &__information {
      font-size: 12px;
      color: #494949;
      line-height: 1;
    }
  }
</style>